/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/jsx-no-bind */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import withJobActions from './withJobActions';
import entityDropdownButtonFactory from '../../../common/lookups/entityDropdownButtonFactory';
import PhaseCodeItem from '../../../admin/jobs/jobPhaseCodeItem';
import useLookup from '../../../../utils/useLookup';
const PhaseCodeDropdown = entityDropdownButtonFactory('phaseCode');
const JobPhaseCodesSubsection = props => {
  const _props$active = props.active,
    _props$active$phaseCo = _props$active.phaseCodes,
    phaseCodes = _props$active$phaseCo === void 0 ? [] : _props$active$phaseCo,
    activeID = _props$active.id,
    onJobRemove = props.onJobRemove,
    onJobAdd = props.onJobAdd,
    onJobChange = props.onJobChange;
  const handleRemove = useCallback(index => onJobRemove('phaseCodes', index), [onJobRemove]);
  const handleChange = useCallback((index, _ref) => {
    let value = _ref.value,
      name = _ref.name;
    return onJobChange("phaseCodes/".concat(index, "/").concat(name), value);
  }, [onJobChange]);
  const handleAdd = useCallback(phaseCode => {
    const defaultData = {
      jobID: activeID,
      phaseCodeID: phaseCode !== 'Other' ? phaseCode.id : null,
      name: phaseCode !== 'Other' ? phaseCode.name : ''
    };
    onJobAdd('phaseCodes', defaultData);
  }, [activeID, onJobAdd]);
  const phaseCodeNames = phaseCodes.map(pc => pc.name);
  return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", null, useLookup('Phase Code')), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("section", null, phaseCodes.map((nextPC, index) => /*#__PURE__*/React.createElement(PhaseCodeItem, {
    index: index,
    data: nextPC,
    key: nextPC.id,
    onChange: handleChange,
    onRemove: handleRemove
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: {
      size: 3,
      offset: 9
    }
  }, /*#__PURE__*/React.createElement(PhaseCodeDropdown, {
    onAdd: handleAdd,
    names: phaseCodeNames,
    enforceUniqueNames: true,
    title: "Add ".concat(useLookup('Phase Code')),
    includeOther: true,
    entity: "PhaseCode"
  }))));
};
JobPhaseCodesSubsection.propTypes = {
  active: PropTypes.shape({
    id: PropTypes.string,
    phaseCodes: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string
    }))
  }).isRequired,
  onJobAdd: PropTypes.func.isRequired,
  onJobChange: PropTypes.func.isRequired,
  onJobRemove: PropTypes.func.isRequired
};
export { JobPhaseCodesSubsection as UncomposedJobPhaseCodesSubsection };
export default withJobActions(JobPhaseCodesSubsection);